import { useMemo } from 'react';
import { useRoutesContext } from '../';

import { StationCode } from 'entities/map';

import { EMPTY_ARRAY } from 'shared/constants';

export const useFlatRoutesStationRecommendations = () => {
  const { activeRoute } = useRoutesContext();
  const { perCountry = EMPTY_ARRAY } = activeRoute?.stationRecommendations || {};

  const flatRoutesStationRecommendations = useMemo(() => (
    perCountry.reduce((acc, { bestPriceStations }) => ([...acc, ...bestPriceStations]), [] as StationCode[])
  ), [perCountry]);

  return flatRoutesStationRecommendations;
};
